/**
 * @generated SignedSource<<2cc8c22d9eb852fdbfdc30180205ba57>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ProjectVersionFileKind = "DATA" | "PACKAGE" | "SUBMISSION_EVALUATION" | "TEMPLATE";
import { FragmentRefs } from "relay-runtime";
export type ProjectFileBrowserFragment$data = {
  readonly __typename: string;
  readonly id: string;
  readonly version: {
    readonly fileByKind: {
      readonly id: string;
      readonly kind: ProjectVersionFileKind;
      readonly " $fragmentSpreads": FragmentRefs<"ProjectDownloadButtonFragment">;
    } | null | undefined;
    readonly files: ReadonlyArray<{
      readonly id: string;
      readonly kind: ProjectVersionFileKind;
    }>;
    readonly version: string;
  } | null | undefined;
  readonly " $fragmentType": "ProjectFileBrowserFragment";
};
export type ProjectFileBrowserFragment$key = {
  readonly " $data"?: ProjectFileBrowserFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ProjectFileBrowserFragment">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": "TEMPLATE",
      "kind": "LocalArgument",
      "name": "kind"
    },
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "version"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "ProjectFileBrowserFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "version",
          "variableName": "version"
        }
      ],
      "concreteType": "ProjectVersion",
      "kind": "LinkedField",
      "name": "version",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "version",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "ProjectVersionFile",
          "kind": "LinkedField",
          "name": "files",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/)
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "kind",
              "variableName": "kind"
            }
          ],
          "concreteType": "ProjectVersionFile",
          "kind": "LinkedField",
          "name": "fileByKind",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            (v1/*: any*/),
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "ProjectDownloadButtonFragment"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Project",
  "abstractKey": "__isProject"
};
})();

(node as any).hash = "63b2bb94453db12b7b59e77023e01fbb";

export default node;
